import * as React from "react"
import styled from "styled-components"
import ZoomOnScroll from "./ZoomOnScroll"

export interface BannerProps extends React.PropsWithChildren {
  imageSrc: string
  imageAlt: string
  imagePos?: React.CSSProperties["objectPosition"]
}

const BannerContainer = styled.div`
  position: relative;
  clip-path: inset(0);
  height: 100vh;
`

const ContentContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const Image = styled.img<{ objectPosition: React.CSSProperties["objectPosition"] }>`
  width: 100%;
  height: 100vh;
  object-fit: cover;
  object-position: ${({ objectPosition }) => objectPosition ?? "center"};

  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`

const Banner: React.FC<BannerProps> = ({ children, imageAlt, imageSrc, imagePos }) => {
  return (
    <ZoomOnScroll>
      <BannerContainer>
        <Image objectPosition={imagePos} src={imageSrc} alt={imageAlt} />
        <ContentContainer>{children}</ContentContainer>
      </BannerContainer>
    </ZoomOnScroll>
  )
}

export default Banner
